import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { Settings } from '@/components/Settings';
import { closePanelAtom } from '@/stores/panels';
import { useSetAtom } from 'jotai';

export function SettingsPanel() {
  const closePanel = useSetAtom(closePanelAtom);

  return (
    <ResponsivePanelWrapper panelId="settings" title="Settings">
      <Settings onBack={() => closePanel('settings')} />
    </ResponsivePanelWrapper>
  );
}

export default SettingsPanel;
